export default "__VITE_ASSET__CH870aS9__"